<template>
    <div>
        <van-notify v-model="showNotice" message="请关注官方公众号" type="danger" @click="showQRcode()">
            <van-icon name="bell" style="margin-right: 4px;" />
        </van-notify>
        <div class="page-header">
            <img :src="memberInfo.headimgurl">
            <div class="page-header-title">
                <h5 class="site-desc">昵 称：{{memberInfo.nickname}}</h5>
                <p class="site-desc">设备号：{{iccid}}</p>
                <!--<p class="site-desc">apn设置：<a :stylle="{color:'#2398e6'}" href="http://baidu.com">详细教程</a></p>-->
            </div>
        </div>
        <div class="home-nav">
            <van-row  justify="center" class="">
                <van-col span="8">
                    <div @click="$router.push({name:'index'})" class="">
                        <img src="../assets/images/query.fd2e6f2c.png">
                        <p>查询</p>
                    </div>
                </van-col>
                <van-col span="8">
                    <div @click="$router.push({name:'recharge',query:{iccid:iccid}})" class="">
                        <img src="../assets/images/recharge.png">
                        <p>续费</p>
                    </div>
                </van-col>
                <van-col span="8">
                    <div @click="$router.push({name:'bind'})" class="">
                        <img src="../assets/images/auth.46bece58.png">
                        <p>查询设备</p>
                    </div>
                </van-col>
                <van-col span="8">
                    <div @click="$router.push({name:'order',query:{iccid:iccid}})" class="">
                        <img src="../assets/images/order.edc98302.png">
                        <p>续费记录</p>
                    </div>
                </van-col>
                <van-col span="8" v-if="customerUrl">
                    <a :href="customerUrl" class="">
                        <img src="../assets/images/feedback.eb8634f3.png">
                        <p>联系客服</p>
                    </a>
                </van-col>
              <van-col span="8" v-else>
                <div @click="$router.push({name:'feedback'})" class="">
                  <img src="../assets/images/feedback.eb8634f3.png">
                  <p>投诉建议</p>
                </div>
              </van-col>
                <van-col span="8">
                    <div @click="checkCard" class="">
                        <img src="../assets/images/check.png">
                        <p>智能检测</p>
                    </div>
                </van-col>
              <van-col span="8">
                <div @click="showChangeNetFuc" v-if="operator.changeNet == 1" class="">
                  <img src="../assets/images/network.png">
                  <p>三网切换</p>
                </div>
              </van-col>
                <van-col span="8" v-if="operator.exchangeSwitch==1">
                    <div @click="changeCard(iccid)" class="">
                        <img src="../assets/images/change.png">
                        <p>申请更换</p>
                    </div>
                </van-col>
                <van-col span="8" v-if="operator.activeLimit==3">
                    <div @click="apply(iccid)" class="">
                        <svg t="1620390731825" class="icon" style="width: .8rem;height: .8rem;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1625" width="200" height="200"><path d="M904.795187 932.547761v-261.367849L596.773442 980.79213l-242.282164 41.882475h458.85167a91.452239 91.452239 0 0 0 91.452239-90.126844z" p-id="1626" fill="#1296db"></path><path d="M451.245097 799.213047l339.831219-336.915351 151.625162 152.950557-339.566141 336.91535zM374.902358 1017.107947L589.351232 967.273104l-151.890241-153.215636zM1006.055348 495.962723l-94.103029-95.163344a41.352317 41.352317 0 0 0-57.787212 0l-47.714212 47.184054 151.890241 153.215635 47.449133-47.184054a41.352317 41.352317 0 0 0 0.265079-58.052291z" p-id="1627" fill="#1296db"></path><path d="M813.342948 0h-715.713176A91.452239 91.452239 0 0 0 6.177532 91.452239v841.095522a91.452239 91.452239 0 0 0 91.45224 91.452239h256.861506l67.064976-219.220295 450.634222-446.658038A44.003106 44.003106 0 0 1 904.795187 344.60264V91.452239A91.452239 91.452239 0 0 0 813.342948 0zM333.81512 753.884546h-159.047373a26.507895 26.507895 0 0 1 0-53.015791h159.047373a26.507895 26.507895 0 1 1 0 53.015791z m177.072741-265.078954H173.707432a26.507895 26.507895 0 1 1 0-53.015791H509.827545a26.507895 26.507895 0 0 1 0 53.015791z m223.19648-265.078955H173.707432a26.507895 26.507895 0 0 1 0-53.015791h560.11183a26.507895 26.507895 0 1 1 0 53.015791z" p-id="1628" fill="#1296db"></path></svg>
                        <p>申请激活</p>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="warm-tips" :style="{background: '#fff'}"><h5>说明</h5>
            <ol>
                <li>本设备需要实名认证续费方可使用。（点击上方实名认证按提示规范操作。实名成功后续费）</li>
                <li>为保证此设备稳定使用请不要随便更换设备</li>
            </ol>
        </div>
        <van-dialog v-model="showQRcodeModal" :showConfirmButton="false" title="长按关注官方公众号">

                <img :src="qrcodeurl" style="display: block;width: 100%;"/>
                <div >续费查询，24小时客服在线</div>
            <a v-clipboard:copy="iccid" v-clipboard:success="onCopySuccess"
               v-clipboard:error="onCopyError" style="padding: .2rem 0;display: block;color: #3a8ee6">复制编号
            </a>
        </van-dialog>
      <van-action-sheet v-model="showChangeNet" description="网络切换成功后，请关闭设备，等待设置同步，5分钟后再开机使用" :actions="netList" @select="onChangeNet" cancel-text="取消" close-on-click-action />
    </div>
</template>
<script>
    import Vue from "vue";
    import VueClipboard from 'vue-clipboard2'

    Vue.use(VueClipboard)
    export default {
        name: "App",
        data: () => ({

            token: '',
            memberInfo: {},
            iccid:'',
            cardlist:[],
            operator:{},
            showNotice:false,
            showQRcodeModal:false,
            showContent:false,
            qrcodeurl:'',
          showChangeNet:false,
          customerUrl:'',
          netList:[
            {name:'中国电信',value:'dianxin'},
            {name:"中国联通",value:'liantong'},
            {name:"中国移动",value:'yidong'}
          ]
        }),
        watch: {
            iccid(value) {
                sessionStorage.setItem('iccid', this.iccid)
                this.subscribeStatus()
                this.queryOperatorInfo();
            }
        },
        created() {
            if(this.$route.query.appid && this.$route.query.appid > 0){
                sessionStorage.setItem('appid',this.$route.query.appid)
            }
            this.fetchData('/member/info', {}, (res) => {
                if (res.code) {
                    this.memberInfo = res.data
                    if(this.memberInfo.subscribe == 0){
                        this.showNotice = true
                    }
                }
            })
            this.queryUserCards();
            this.fetchData('/config/customerUrl',{},res=>{
              if(res.data){
                this.customerUrl = res.data
              }
            })
        },
        methods: {
          showChangeNetFuc(){
            let network = localStorage.getItem('network')
            if(network){
              for (let i in this.netList){
                this.netList[i].disabled = false
                if(this.netList[i].value == network){
                  this.netList[i].disabled = true
                }
              }
            }

            this.showChangeNet = true
          },
          onChangeNet(action){
            this.$toast.loading({message:'切换中',duration:6000})
            setTimeout(()=>{
                this.$dialog.alert({
                  message: '切换成功，请关闭设备，等待设置同步，5分钟后再开机使用',
                })
            },6000)
            localStorage.setItem('network',action.value)
            this.showChangeNet = false
          },
            apply(iccid){
                this.$router.push({name:'applyrecharge',query:{iccid:iccid}})
            },
            onCopySuccess() {
                this.$toast.success('复制成功')
            },
            onCopyError() {
                this.$toast.fail('复制失败');
            },
            subscribeStatus(){
                this.fetchData('/auth/subscribeStatus',{iccid:this.iccid},res=>{
                    if(res.code && res.url){
                        this.showQRcodeModal = true
                        this.qrcodeurl = res.url
                    }
                })
            },
            changeCard(iccid){
                this.fetchData('/change/getUrl',{iccid:iccid},(res)=>{
                    if(res.code && res.url){
                        window.location.href = res.url
                    }else{
                        this.$router.push({name:'change',query:{iccid:this.iccid}})
                    }
                })
            },
            queryStatus(){
                this.fetchData('/card/statusChange', {iccid: this.iccid}, (res) => {
                    this.$toast.clear()
                    if (res.code) {
                        if(res.data.change == 1){
                            this.change = 1
                              this.$dialog.alert({
                                  title: "换卡提示",
                                  message: res.msg ? res.msg :"当前设备已不支持续费，我们将为您补发设备",
                                  confirmButtonText: '立即更换',
                                  showCancelButton:true
                              }).then(() => {
                                  this.changeCard(this.iccid)
                              });
                        }else if(res.data.change==2 && res.data.id){
                            this.$dialog.alert({
                                title: false,
                                message: "您已申请更换设备，点击查看更换进度",
                                confirmButtonText: '立即查看',
                                showCancelButton:true
                            }).then(() => {
                                this.$router.push({name:'changeInfo',query:{id:res.data.id}})
                            }).catch(()=>{});

                        }
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            queryUserCards() {
                this.fetchData('/card/querylist', {}, (res) => {
                    if (res.code) {
                        for (var i in res.data) {
                            let card = res.data[i];
                            this.cardlist.push({
                                name: card.iccid,
                                value: card.iccid
                            })
                            if (card.default == 1) {
                                this.iccid = card.iccid;
                            }
                        }
                    } else {
                      this.$router.push({name: 'bind'})
                    }
                })
            },
            queryOperatorInfo() {
                this.fetchData('/card/cardOperator', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.operator = res.data
                        this.queryStatus();
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            checkCard(){
                this.$toast.loading('诊断中')
                this.fetchData('/card/check',{iccid:this.iccid},(res)=>{
                    this.$toast.loading().close();
                    this.$toast(res.msg)
                })
            },
            showQRcode(){
                this.showQRcodeModal = true;
            }
        }
    };
</script>

<style>
    body, html {
        padding: 0;
        margin: 0;
    }

    #app {
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        padding: 0;
        margin: 0;
        padding-bottom: .3rem;
    }

    .page-header {
        height: 2.5rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        background: -webkit-gradient(linear, left top, left bottom, from(#3c6bff), to(#75b2f9));
        background: linear-gradient(#3c6bff, #75b2f9);
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-shadow: 0 0 0.6rem 0.6rem #75b2f9;
        box-shadow: 0 0 0.6rem 0.6rem #75b2f9;
    }

    .page-header img {
        background: #fff;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 2rem;
        border: .05rem solid #75b2f9;
    }

    .page-header .page-header-title {
        color: #fff;
        font-weight: 700;
        text-align: left;
        padding-left: 0;
    }

    .page-header .page-header-title .site-title {
        padding: 0;
        margin: 0;
        line-height: .3rem;
    }

    .page-header .page-header-title .site-desc {
        margin: .1rem 0;
        padding: 0;
        font-size: .3rem;
    }

    .home-nav {
        width: 6.74rem;
        margin: auto;
        padding-top: .1rem;
        padding-bottom: .1rem;
        background: #fff;
        border-radius: .1rem;
        box-shadow: 0 0 0.02rem #dedede;
    }

    .home-nav img {
        margin: 0;
        width: .8rem;
        height: .8rem;
    }

    .home-nav p {
        margin-top: -.1rem;
        font-size: .22rem;
        color: #555;
    }

    .page-footer {
        bottom: .3rem;
        font-size: .16rem;
        color: #555;
        text-align: center;
        width: 7.5rem;
    }

    .page-footer a {
        color: #666;
        text-decoration: #3a8ee6;
    }

    .warm-tips {
        font-size: .25rem;
        margin: 0 .3rem;
        padding: 0 .3rem;
    }

    .warm-tips h5 {
        text-align: left;
        margin: .2rem 0;
        padding-left: .1rem;
        font-size: .3rem;
        border-left: .2rem solid #75b2f9;
    }

    .warm-tips ol {
        text-align: left;
        padding: 0;
        font-size: .24rem;
    }

    .warm-tips ol li {
        list-style: disc;
        line-height: .4rem;
    }

</style>



// WEBPACK FOOTER //
// src/pages/home.vue